module.exports = __webpack_public_path__ + "img/spritemap@2x.png?5f81bf534d62365ad0450dc2f225911a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plugins/dropzone/images/spritemap@2x.png
// module id = 161
// module chunks = 0